import {RawNotify} from '@/types/entity/RawNotify'
import store from '@/store'
import Notify from '@/models/notify/Notify'
import {NOTIFY_TYPE_READ, NOTIFY_TYPE_SELFTEST} from '@/constants'
export default function (event: RawNotify): void {
  switch (event.type) {
    case NOTIFY_TYPE_READ:
      const ids = event.read_ids
      for (const id of ids!) {
        let obj = store.state.notify.notifies[id]
        if (obj) {
          obj.setRead()
        }
      }
      break;
    case NOTIFY_TYPE_SELFTEST:
      store.getters['notify/getItem'](event)
      break;
    default:
      console.error('Uknow notify type', event)
      break;
  }
}